let admin = ["kozbrett@gmail.com", "joel@notrench.net", "heather@notrench.net"];

export default admin;
